import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

import { helpers } from 'styles'

export const BackgroundWrapper = styled.div`
	position: relative;
	height: 100%;
	width: 100%;

	${mobileMediaQuery(css`
		max-height: 140px;
		font-size: ${helpers.font.size.larger};
	`)}
`
